import { styled } from 'styled-components';

export const AccordionHeader = styled.button`
  width: 100%;
  position: relative;
  text-align: left;
  padding: 0;
  height: 3rem;
  ${({ theme }) => theme.typography.headingRegular}

  &:focus {
    outline: none;
  }

  & > svg {
    position: absolute;
    top: 0.78125rem;
    right: 0.78125rem;

    transition: transform ${({ theme }) => theme.animation.duration.default}
      ${({ theme }) => theme.animation.easing.moving};
    ${({ $isExpanded }) => $isExpanded && `transform: rotate(180deg)`};
  }
`;
AccordionHeader.displayName = 'AccordionHeader';

export const AccordionBody = styled.div`
  width: 100%;
  transition: all ${({ theme }) => theme.animation.duration.slow}
    ${({ theme }) => theme.animation.easing.moving};
  overflow: hidden;

  ${({ $isExpanded }) => `
    min-height: ${$isExpanded ? '40px' : '0'};
    max-height: ${$isExpanded ? '2500px' : '0'};
  `}/* > div > div {
    box-shadow: none;
    margin: 0;
  } */
`;
AccordionBody.displayName = 'AccordionBody';
